import { render, staticRenderFns } from "./Embarcaciones.vue?vue&type=template&id=25040589&scoped=true"
import script from "./Embarcaciones.vue?vue&type=script&lang=js"
export * from "./Embarcaciones.vue?vue&type=script&lang=js"
import style0 from "./Embarcaciones.vue?vue&type=style&index=0&id=25040589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25040589",
  null
  
)

export default component.exports